import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, of, switchMap } from 'rxjs';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { supplyContract } from 'src/app/interfaces/supplyContract';
import { User } from 'src/app/interfaces/user';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { SupplyContractService } from 'src/app/services/supply-contract.service';

@Component({
  selector: 'app-sync-customer',
  templateUrl: './sync-customer.component.html',
  styleUrl: './sync-customer.component.scss'
})
export class SyncCustomerComponent implements OnInit {
  finishedLoadingUsers: boolean = false;

  accountForm: FormGroup;
  addressForm: FormGroup;

  accountFormERP: FormGroup;
  addressFormERP: FormGroup;

  searchForm: FormGroup

  dataSource: MatTableDataSource<BusinessUserResource>;
  displayedColumns = ['menu', 'customerNumber', 'user'];
  currentUserResource: User;

  /**
   * The Gendersoptions of the user
   */
  public genderOptions = [
    { value: 'MALE', viewValue: 'Herr' },
    { value: 'FEMALE', viewValue: 'Frau' },
    { value: 'UNDEFINED', viewValue: 'Divers' },
  ]

  contracs: Array<supplyContract> = [];
  contracsERP: Array<supplyContract> = [];

  disableMove1:boolean = false;
  disableMove2:boolean = false;
  disableMove3:boolean = false;
  disableMove4:boolean = false;
  disableMove5:boolean = false;
  disableMove6:boolean = false;
  disableMove7:boolean = false;
  disableMove8:boolean = false;


  constructor(private route: ActivatedRoute,
    private businessuserService: BusinessuserService,
    private fb: FormBuilder,
    private router: Router,
    private overlay: OverlayService,
    private SupplyContractService: SupplyContractService
  ) {
    this.accountForm = this.fb.group({
      customerNumber: [''],
      gender: ['', [Validators.required]],
      title: [''],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      birthday: ['', [Validators.required]],
    })

    this.addressForm = this.fb.group({
      street: ['', [Validators.required]],
      postcode: ['', [Validators.required]],
      city: ['', [Validators.required]],
    })


    this.accountFormERP = this.fb.group({
      customerNumber: [''],
      gender: ['', [Validators.required]],
      title: [''],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      birthday: ['', [Validators.required]],
    })

    this.addressFormERP = this.fb.group({
      street: ['', [Validators.required]],
      postcode: ['', [Validators.required]],
      city: ['', [Validators.required]],
    })

    this.searchForm = this.fb.group({
      searchTerm: ['', []],
    })
  }

  ngOnInit(): void {
    combineLatest([
      this.route.params
    ]).pipe(
      switchMap(([params]) => {
        return combineLatest([
          this.businessuserService.getBuissnessUser(params['id']),
          this.SupplyContractService.getContracts(params['id'])
        ])
      })
    ).subscribe(([user, contracts]: [User, Array<supplyContract>]) => {
      this.contracs = contracts;
      this.currentUserResource = user;
      this.accountForm.patchValue({
        customerNumber: user?.customerNumber,
        gender: user.person?.gender,
        title: user.person?.title,
        firstName: user.person?.firstName,
        lastName: user.person?.lastName,
        birthday: user.person?.birthday,
      })

      this.searchForm.patchValue({
        searchTerm: user?.customerNumber
      })
      this.addressForm.patchValue(user.address)
      this.addressForm.disable();
      this.accountForm.disable();
      this.finishedLoadingUsers = true;
      this.filterCustomers();
    })
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterCustomers()
    }
  }

  filterCustomers() {
    this.businessuserService.getErpUserWithFilter(0, 12, this.searchForm.getRawValue().searchTerm).subscribe((users: PagedResources<BusinessUserResource>) => {
      this.dataSource = new MatTableDataSource(users.content);
      if(users.content.length == 1){
        this.patchData(users.content[0])
      }
    })

  }

  patchData(user) {
    this.accountFormERP.patchValue({
      customerNumber: user.customer.customerNumber,
      gender: user.customer.person?.gender,
      title: user.customer.person?.title,
      firstName: user.customer.person?.firstName,
      lastName: user.customer.person?.lastName,
      birthday: user.customer.person?.birthday,
    })
    this.addressFormERP.patchValue(user.customer.address)
    this.contracsERP = user.customer?.supplyContracts;

    if(user.customer.person?.gender == this.accountForm.getRawValue().gender){
      this.disableMove1 = true
    }
    if(user.customer.person?.title == this.accountForm.getRawValue().title){
      this.disableMove2 = true
    }
    if(user.customer.person?.firstName == this.accountForm.getRawValue().firstName){
      this.disableMove3 = true
    }
    if(user.customer.person?.lastName == this.accountForm.getRawValue().lastName){
      this.disableMove4 = true
    }
    if(user.customer.person?.birthday == this.accountForm.getRawValue().birthday){
      this.disableMove5 = true
    }
    if(this.addressFormERP.getRawValue().street == this.addressFormERP.getRawValue().street){
      this.disableMove6 = true
    }
    if(this.addressFormERP.getRawValue().postcode == this.addressFormERP.getRawValue().postcode){
      this.disableMove7 = true
    }
    if(this.addressFormERP.getRawValue().city == this.addressFormERP.getRawValue().city){
      this.disableMove8 = true
    }
  }


  moveData(index: number) {
    switch (index) {
      case 1:
        this.accountForm.patchValue({ gender: this.accountFormERP.getRawValue().gender })
        break;
      case 2:
        this.accountForm.patchValue({ title: this.accountFormERP.getRawValue().title })
        break;
      case 3:
        this.accountForm.patchValue({ firstName: this.accountFormERP.getRawValue().firstName })
        break;
      case 4:
        this.accountForm.patchValue({ lastName: this.accountFormERP.getRawValue().lastName })
        break;
      case 5:
        this.accountForm.patchValue({ birthday: this.accountFormERP.getRawValue().birthday })
        break;
      case 6:
        this.addressForm.patchValue({ street: this.addressFormERP.getRawValue().street })
        break;
      case 7:
        this.addressForm.patchValue({ postcode: this.addressFormERP.getRawValue().postcode })
        break;
      case 8:
        this.addressForm.patchValue({ city: this.addressFormERP.getRawValue().city })
        break;
      default:
        break;
    }
  }
  editUser() {
    this.currentUserResource.person.gender = this.accountForm.getRawValue().gender;
    this.currentUserResource.person.title = this.accountForm.getRawValue().title;
    this.currentUserResource.person.firstName = this.accountForm.getRawValue().firstName;
    this.currentUserResource.person.lastName = this.accountForm.getRawValue().lastName;
    this.currentUserResource.person.birthday = this.accountForm.getRawValue().birthday;

    if (this.currentUserResource.address == null) {
      this.currentUserResource.address = {
        city: this.addressForm.getRawValue().city,
        postcode: this.addressForm.getRawValue().postcode,
        street: this.addressForm.getRawValue().street,
      }
    } else {
      this.currentUserResource.address.city = this.addressForm.getRawValue().city;
      this.currentUserResource.address.postcode = this.addressForm.getRawValue().postcode;
      this.currentUserResource.address.street = this.addressForm.getRawValue().street;
    }
    this.contracsERP.forEach((contract: supplyContract) => {
      if (contract.contractState == "RUNNING" && contract.contractType != "ACCOUNT") {
        this.SupplyContractService.editContract(this.currentUserResource.publicId, contract).subscribe();
      }
    });
    this.businessuserService.editBuissnessUser(this.currentUserResource).subscribe(value => {
      this.overlay.openSnackBar("Kunde erfolgreich geändert!");
    })
  }
}
